export function onlyNumberFormatter(value: string): string {
  if (!value) {
    return '';
  }
  const valueClean = value.replace(/[^0-9]/g, '');
  return valueClean;
}
